import { LoadingOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { Input } from 'sutra/components/Input/Input'
import { NumberField } from 'sutra/components/NumberField/NumberField'

import {
  buttonBlue,
  cardBorder,
  cardBorderGrey,
  cardBoxShadow,
  errorRed,
  greyBackgroundAlternate,
  lightBlueFontColor,
  pageBackgroundGrey,
  secondaryNavy,
  toggleBorderSelected,
  toggleBorderUnselected,
} from 'assets/styles/variables'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${pageBackgroundGrey};
  position: relative;
  font-size: 13px;
`

export const Header = styled.div`
  padding: var(--default-padding-half) var(--default-padding) 5px;
  border-bottom: 1px solid #f2f2f2;
`

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  padding: 10px 27px;
`

export const Section = styled.div`
  margin-top: 18px;
  font-size: 13px;
`

export const Footer = styled.div`
  background: ${greyBackgroundAlternate};
  padding: 10px 27px 20px;
  display: flex;
  flex-direction: column;
  min-height: 350px;
  overflow: auto;
`

export const MinReviewWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: 12px;
  padding: 0 29px 0 32px;
`

export const Overlay = styled.div`
  background: rgba(255, 255, 255, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const ControlsCard = styled.div`
  padding: 20px 15px 20px;
  border-radius: 10px;
  border: 2px solid ${cardBorder};
  box-shadow: ${cardBoxShadow};
  //position: relative;
`

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 15px;
  min-width: 0;
`

export const Form = styled.form`
  height: 100%;
  overflow: auto;
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 100%;
`
export const CustomButtonGroupItem = styled.div<{ $isSelected: boolean }>`
  background: ${({ $isSelected }) =>
    $isSelected ? 'white' : toggleBorderUnselected};
  border: ${({ $isSelected }) =>
    $isSelected ? '1px solid' + toggleBorderSelected : '1px solid transparent'};
  box-shadow: ${({ $isSelected }) =>
    $isSelected ? '0px 4px 4px 0px #0000001A' : 'none'};
  text-align: center;
  font-size: 13px;
  padding: 8px;
  cursor: pointer;
  color: ${lightBlueFontColor};
  z-index: ${({ $isSelected }) => ($isSelected ? 2 : 1)};
  &:hover {
    border: 1px solid ${secondaryNavy};
    z-index: 3;
  }
  transition: all 0.2s;
`

export const StyledInput = styled(Input)<{ $isError: boolean }>`
  background: white;
  border-color: ${({ $isError }) =>
    $isError ? errorRed : 'rgb(239, 240, 246)'};
  border-radius: 10px;
  border: 2px solid ${cardBorderGrey};
  &:hover {
    border-color: ${buttonBlue};
  }
  &:focus {
    border-color: ${buttonBlue};
  }
  font-size: 13px;
  padding: 9px 16px;
`

export const ButtonSpinner = styled(LoadingOutlined)`
  color: #fff;
  font-size: 14px;
`

export const StyledNumberField = styled(NumberField)`
  min-width: 80px;
`

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 16px;
`

export const ErrorMessage = styled.div`
  color: red;
`
